export const PURCHASE_GIFT_CARD_ASSORTMENT = 'PURCHASE_GIFT_CARD_ASSORTMENT';

export function setPurchasedGiftCardAssortment(payload) {
  return {
    type: PURCHASE_GIFT_CARD_ASSORTMENT,
    payload,
  };
}
